import { Trans } from '@lingui/react/macro';
import { Tabs, TabsList, TabsTrigger } from '@repo/videa-components';
import { useAtom } from 'jotai';

import { usePreferences } from '@/react-query/usePreferences';

import { ambientViewTypeAtom } from '../patientList/atoms';

const TABS_TRIGGER_CLASSNAME =
  'vai-px-6 vai-pt-3 vai-pb-3 vai-text-sm vai-font-medium data-[state=active]:vai-bg-transparent vai-border-b-2 vai-border-transparent data-[state=active]:vai-border-blue-600 !vai-rounded-none !vai-shadow-none vai-text-gray-600 data-[state=active]:vai-text-blue-600 vai-transition-colors';

export const AmbientViewTabs = () => {
  const [ambientViewType, setAmbientViewType] = useAtom(ambientViewTypeAtom);
  const { data: preferences } = usePreferences();

  if (!preferences?.enableVoiceNotesCustomTemplates) {
    return null;
  }

  return (
    <div className="vai-bg-white vai-border-b vai-border-gray-200 vai-px-4">
      <Tabs
        value={ambientViewType}
        onValueChange={(value) =>
          setAmbientViewType(value as 'notes' | 'templates')
        }
      >
        <TabsList className="vai-bg-transparent vai-border-b vai-border-transparent vai-rounded-none vai-pb-0 vai-px-0 vai-h-auto">
          <TabsTrigger value="notes" className={TABS_TRIGGER_CLASSNAME}>
            <Trans>Notes</Trans>
          </TabsTrigger>
          <TabsTrigger value="templates" className={TABS_TRIGGER_CLASSNAME}>
            <Trans>Templates</Trans>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};
